import React from "react"

interface Props {
    isDisabled: boolean
    value: string | undefined
    setValue: React.Dispatch<React.SetStateAction<string | undefined>> | ((_value: string) => void) | undefined
    tabIndex: number | undefined
    placeholder: string | undefined
    _ref?: any
    labelText: string | undefined
    isLabelRequired: boolean
    height?: string,
    isSolid: boolean
}

const CustomTextInput = ({
    isDisabled,
    value,
    setValue,
    tabIndex,
    placeholder,
    _ref,
    labelText,
    isLabelRequired,
    height,
    isSolid
}: Props) => {
    return (
        <React.Fragment>
            {
                labelText && (
                    <label className={"form-label " + (isLabelRequired ? 'required' : '')}>{labelText}</label>
                )
            }
            <input ref={_ref} placeholder={placeholder} tabIndex={tabIndex} disabled={isDisabled} style={{ height, background: (isDisabled ? '#f1f1f4' : undefined), border: '1px solid #F1F1F4' }} value={value ?? ''} onChange={setValue ? (e) => setValue(e.target.value) : undefined} type="text" className={"form-control " + (isSolid ? 'form-control-solid' : '')} />
        </React.Fragment>
    )
}

CustomTextInput.defaultProps = {
    isDisabled: false,
    setValue: undefined,
    tabIndex: undefined,
    placeholder: undefined,
    labelText: undefined,
    isLabelRequired: false,
    isSolid: true
}

export default CustomTextInput;